/**
 * Frontend init for the Products Elementor widget — plain Widget_Base, no
 * Nested Elements complexity (unlike the Slider widget), so this is ONE
 * unconditional script that works correctly in both the editor preview
 * iframe and the live page, same pattern as elementor-youtube-feed.js:
 * `frontend/element_ready` reliably re-fires on every full AJAX re-render
 * in both contexts, since every settings change on a plain Widget_Base
 * triggers a real server round-trip (no client-side-only DOM mutation
 * path the way the Slider's repeater has). No isEditMode() branching
 * needed at all.
 *
 * Two responsibilities:
 * 1. If the widget rendered in carousel layout, initialize it via the
 *    shared dist/js/elementor-swiper-carousel.js (also used by the
 *    Slider widget) — no-ops harmlessly if the layout is grid (no
 *    `.swiper` element to find).
 * 2. Explicitly call window.GWSInitProductCardQuantity() — confirmed by
 *    reading elementor-product-card-quantity.js that it only
 *    self-registers against `frontend/element_ready/gws-product-card.default`,
 *    so a page using only this Products widget (no standalone Product
 *    Card widget) would otherwise never get the quantity-stepper
 *    takeover. Harmless to call even when it's already run — that
 *    function's own `initialized` guard makes repeat calls a no-op.
 */
( function () {
	'use strict';

	function registerElementReadyHook() {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/gws-products.default', function ( $scope ) {
			var carousel = $scope[ 0 ].querySelector( '.gws-products--carousel .swiper' );

			if ( carousel ) {
				window.GWSInitSwiperCarousel( carousel );
			}

			if ( window.GWSInitProductCardQuantity ) {
				window.GWSInitProductCardQuantity();
			}
		} );
	}

	if ( window.elementorFrontend && window.elementorFrontend.hooks ) {
		registerElementReadyHook();
	} else {
		window.addEventListener( 'elementor/frontend/init', registerElementReadyHook );
	}
} )();
